/* unplugin-vue-components disabled */import script from "./AccountDisabledNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountDisabledNotice.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__